import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { cn } from '~/helpers/utils.ts';

export type ToggleRadioOption<T = any> = {
  value: T;
  label: string;
};

type ToggleRadioFieldProps<T = any> = {
  name: string;
  label?: string;
  description?: string;
  options: ToggleRadioOption<T>[];
  gridClassName?: string;
  labelClassName?: string;
};

export const ToggleRadioField: React.FC<ToggleRadioFieldProps> = ({
  name,
  label,
  description,
  options,
  gridClassName,
  labelClassName,
}) => {
  const { control } = useFormContext();

  return (
    <fieldset>
      {/* Note: Div is needed here, fieldset has a bug with flexbox styling, but keeping it for semantics */}
      <div className="form-control">
        {label && <legend className="form-label">{label}</legend>}

        {description && <p>{description}</p>}

        <Controller
          name={name}
          control={control}
          render={({ field, fieldState }) => (
            <>
              <div
                className={cn(gridClassName ?? 'flex h-10 items-center gap-3')}
              >
                {options.map((option, index) => {
                  const inputId = `field-${name}-option-${index}`;

                  return (
                    <div key={option.label} className="form-toggle">
                      <input
                        type="radio"
                        id={inputId}
                        checked={field.value === option.value}
                        onChange={() => field.onChange(option.value)}
                        className="hidden"
                      />
                      <label
                        htmlFor={inputId}
                        tabIndex={0}
                        className={labelClassName}
                      >
                        <span className="form-toggle__orb" />
                        {option.label}
                      </label>
                    </div>
                  );
                })}
              </div>

              {fieldState.error && (
                <span className="text-sm text-tomato-600">
                  {fieldState.error.message}
                </span>
              )}
            </>
          )}
        />
      </div>
    </fieldset>
  );
};
